import classNames from 'classnames';
import AddIcon from 'style-guide/Icons/BlockActions/Add';
import MenuTriggerButton from './style/MenuTriggerButton';

const MenuTrigger = ({ menuOpen, onMenuClose, onMenuOpen, isEditorFocused }) => {
  const onMouseDown = (e) => {
    e.preventDefault();
    if (menuOpen) {
      onMenuClose();
    } else {
      onMenuOpen();
    }
  };

  return isEditorFocused ? (
    <MenuTriggerButton onMouseDown={onMouseDown} className={classNames({ 'add-icon-open': menuOpen })} type='button'>
      <AddIcon />
    </MenuTriggerButton>
  ) : null;
};

export default MenuTrigger;
